module.exports = __webpack_public_path__ + "img/Thailand.1148a3e9.png";